import { BaseAPI } from "../base/service";
import { CourseType } from "../enums";
import { Exam, ExamAnswerResults, SendExamAnswer } from "../exam/dto";

export class LongExamAPI extends BaseAPI {
    private year: number = new Date().getFullYear();

    public getList(courseType: CourseType): Promise<Exam[]> {
        return this.api.get(`${courseType}/${this.year}/long-exam/`);
    }

    public get(courseType: CourseType, examId: number): Promise<ExamAnswerResults> {
        return this.api.get(`${courseType}/${this.year}/long-exam/${examId}/`);
    }

    public sendAnswers(courseType: CourseType, payload: SendExamAnswer): Promise<ExamAnswerResults> {
        return this.api.post(`${courseType}/${this.year}/long-exam-answer/`, payload);
    }
}